module.exports = __webpack_public_path__ + "img/iphone-rfidcard-NETHERLANDS-nl.4b1eea5f.png";